/* unplugin-vue-components disabled */import { render } from "./domstyle.vue?vue&type=template&id=f703a5d0&scoped=true"
import script from "./domstyle.vue?vue&type=script&lang=js"
export * from "./domstyle.vue?vue&type=script&lang=js"

import "./domstyle.vue?vue&type=style&index=0&id=f703a5d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f703a5d0"]])

export default __exports__